function showMessage(notificationMessage, notificationStatus = 'primary', timeoutMilliseconds = 8000) {
    if (notificationStatus == 'danger') {
        /* An error
         * We don't need to do anything here, an Axios interceptor handles this.
         */
    }
    else if (notificationStatus == 'warning') {
        UIkit.modal.alert(notificationMessage, {
            stack: true
        });
    }
    else {
        /* Not an error */
        UIkit.notification({
            message: notificationMessage,
            status: notificationStatus,
            pos: 'top-right',
            timeout: timeoutMilliseconds
        });
    }
}

export default {
    showMessage
};